import React from "react";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";
import {Dictionary} from "../../../database/dictionary";

class WorkSection extends React.Component {
    render() {
        const {classes} = this.props;
        return (
            <div className={classes.section}>
                <GridContainer justify="center">
                    <GridItem cs={12} sm={12} md={8}>
                        <h2 className={classes.title}>Need help with your project or business?</h2>
                        <h4 className={classes.description}>
                            Leave me a message via form below or send me <a href={"mailto: " + Dictionary.email}>an
                            email</a>.<br/>I will get back to you as soon as possible.
                        </h4>
                        <form action="https://formspree.io/me@chriswrobel.com"
                              method="POST">
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <CustomInput
                                        labelText="Your Name"
                                        id="name"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "text",
                                            name: "name"
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <CustomInput
                                        labelText="Your Email"
                                        id="email"
                                        inputProps={{
                                            type: "email",
                                            name: "_replyto"
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <CustomInput
                                    labelText="Your Message"
                                    id="message"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.textArea
                                    }}
                                    inputProps={{
                                        multiline: true,
                                        rows: 5,
                                        type: "text",
                                        name: "message"
                                    }}
                                />

                            </GridContainer>
                            <GridContainer justify="center">
                                <GridItem
                                    xs={12}
                                    sm={12}
                                    md={4}
                                    className={classes.textCenter}
                                >
                                    <Button type="submit" value="Send" color="action"><h4>Send Message</h4></Button>
                                </GridItem>
                            </GridContainer>
                        </form>

                    </GridItem>
                </GridContainer>

            </div>
        );
    }
}

export default withStyles(workStyle)(WorkSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/WorkSection.jsx